import { render, staticRenderFns } from "./titleText.vue?vue&type=template&id=52e1a9b4&"
import script from "./titleText.vue?vue&type=script&lang=js&"
export * from "./titleText.vue?vue&type=script&lang=js&"
import style0 from "./titleText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports